import { defineBoot } from '#q-app/wrappers'
import * as Sentry from '@sentry/capacitor'
import * as SentryVue from '@sentry/vue'
import config from 'app/package.json'

export const sentry = {
  captureException: (exception: any) => Sentry.captureException(exception),
  setUser: (user: any) => Sentry.setUser(user),
}

export default defineBoot(({ app }) => {
  Sentry.init(
    {
      app,
      dsn: 'https://22d9a982801601b689027c2d1b1905fb@o347607.ingest.sentry.io/4506157442662400',
      sampleRate: 1.0,
      tracesSampleRate: 1.0,
      debug: true,
      environment: process.env.QTM_ENV,
      enabled: true, // process.env.QTM_ENV !== 'dev',
      release: `qtm-app-mobile@${config.version}`,
    },
    SentryVue.init,
  )
})
